// utils/menuBuilder.ts

import { Category, Role, ROUTE_CONFIG, RouteAccess } from "../components/NavBar/MenuItems";

type GroupedRoutes = Record<string, RouteAccess[]>;

export const generateMenuByAccess = (role: Role, category: Category): GroupedRoutes => {
  const grouped: GroupedRoutes = {};

  ROUTE_CONFIG.forEach((route) => {
    if (route.canAccess(role, category) && route.showInMenu !== false) {
      const group = route.navGroup || 'Other';
      if (!grouped[group]) grouped[group] = [];
      grouped[group].push(route);
    }
  });
  

  return grouped;
};
